// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"a25926b1","326":"226a4c43","591":"802c2790","950":"e8f9cbf0","977":"89bdfa24"}[chunkId] + ".chunk.js";
};